// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SliderAnimation-container-CoqCX {
	margin: 0 auto;
	padding-bottom: 24px;
	max-width: 1274px;
	padding: 0px 15px;
}

.SliderAnimation-homeCarsoual-FGqLu {
	position: absolute;
	width: 100%;
	height: 100vh;
	top: 0;
}

.SliderAnimation-homePosition-qyixY {
	position: relative;
	height: 100vh;
}

.SliderAnimation-sliderContent-OWA11 {
	position: relative;
	padding-top: 180px;
	padding-bottom: 180px;
	max-width: 770px;
	margin: 0 auto;
}

.SliderAnimation-bgHeight-luFqo {
	height: 100vh;
	width: calc(100% + 5px);
	margin-left: -4px;
}

.SliderAnimation-sliderContent-OWA11 h1 {
	color: var(--white-text);
	line-height: 54px;
	text-align: center;
	margin: 38px 0 18px;
	font-size: 48px;
}

.SliderAnimation-searchCss-jJAqN {
	height: 56px;
	padding: 0 0 0 65px;
	font-size: 20px;
}

.SliderAnimation-searchbox-NIQHA {
	position: relative;
}

.SliderAnimation-searchIcon-JQ9ZT {
	position: absolute;
	top: 17px;
	left: 16px;
}

.SliderAnimation-searchButton-ug6tF {
	position: absolute;
	top: 7px;
	right: 12px;
}

.SliderAnimation-searchButton-ug6tF button {
	color: var(--white-text);
	background-color: var(--btn-primary-bg) !important;
	border-color: var(--btn-primary-bg) !important;
	font-size: 17px;
	padding: 8px 13px;
}

.SliderAnimation-btn-danger-rnqus.SliderAnimation-active-ZmYYO.SliderAnimation-focus-vghdL,
.SliderAnimation-btn-danger-rnqus.SliderAnimation-active-ZmYYO:focus,
.SliderAnimation-btn-danger-rnqus.SliderAnimation-active-ZmYYO:hover,
.SliderAnimation-btn-danger-rnqus:active.SliderAnimation-focus-vghdL,
.SliderAnimation-btn-danger-rnqus:active:focus,
.SliderAnimation-btn-danger-rnqus:active:hover,
.SliderAnimation-open-bVz8z>.SliderAnimation-dropdown-toggle-c0Gs8.SliderAnimation-btn-danger-rnqus.SliderAnimation-focus-vghdL,
.SliderAnimation-open-bVz8z>.SliderAnimation-dropdown-toggle-c0Gs8.SliderAnimation-btn-danger-rnqus:focus,
.SliderAnimation-open-bVz8z>.SliderAnimation-dropdown-toggle-c0Gs8.SliderAnimation-btn-danger-rnqus:hover {
	color: var(--white-text);
	background-color: var(--btn-primary-bg) !important;
	border-color: var(--btn-primary-bg) !important;
}

.SliderAnimation-homeCarsoualMobile-qIi9H {
	display: none;
}

.SliderAnimation-downArrow-HusU9 {
	position: absolute;
	bottom: 10px;
	left: 0;
	right: 0;
	z-index: 0;
	text-align: center;
	-webkit-animation: SliderAnimation-bounce-ZrSKW 2s infinite;
	animation: SliderAnimation-bounce-ZrSKW 2s infinite;
}

@-webkit-keyframes SliderAnimation-bounce-ZrSKW {

	0%,
	20%,
	50%,
	80%,
	100% {
		-webkit-transform: translateY(0);
		        transform: translateY(0);
	}

	40% {
		-webkit-transform: translateY(-20px);
		        transform: translateY(-20px);
	}

	60% {
		-webkit-transform: translateY(-10px);
		        transform: translateY(-10px);
	}
}

@keyframes SliderAnimation-bounce-ZrSKW {

	0%,
	20%,
	50%,
	80%,
	100% {
		-webkit-transform: translateY(0);
		        transform: translateY(0);
	}

	40% {
		-webkit-transform: translateY(-20px);
		        transform: translateY(-20px);
	}

	60% {
		-webkit-transform: translateY(-10px);
		        transform: translateY(-10px);
	}
}

.SliderAnimation-downArrow-HusU9 img {
	display: inline-block;
}

.SliderAnimation-FormBookWrap-n8yxr {
	position: relative;
}

.SliderAnimation-BookWrap-WRupq {
	position: absolute;
	top: 150px;
	background: var(--primary-white-bg);
	padding: 30px;
	border-radius: 6px;
	width: 450px;
	border: 1px solid var(--primary-border);
	z-index: 1;
}

.SliderAnimation-BookWrap-WRupq h1 span {
	margin: 0 0 10px;
	color: var(--btn-primary-bg);
}

.SliderAnimation-BookWrap-WRupq h1 {
	margin: 0;
}

.SliderAnimation-height100-vetXF {
	height: 100%;
}

.SliderAnimation-layoutThreeFormSection-N87QI {
	background: var(--primary-white-bg);
	padding: 30px;
	border-radius: 6px;
	max-width: 450px;
	border: 1px solid var(--primary-border);
}

.SliderAnimation-layoutOneAndThreeHomeBanner-wdVEt {
	background: var(--homePage-Banner-bg);
	width: 100%;
	height: 100%;
}

.SliderAnimation-formHeading-p2WMn {
	color: var(--btn-primary-bg);
	margin-bottom: 12px;
}

.SliderAnimation-layoutOneAndThreeBgSize-FsJaf {
	width: 100%;
	height: 100%;
	position: relative;
	min-height: 768px;
}

.SliderAnimation-layoutOneAndThreeBgImg-dBgup {
	width: 100%;
	height: 100%;
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	position: absolute;
	inset: 0;
}

.SliderAnimation-layoutThreeFormContainer-tvAOg {
	padding-top: 144px;
	padding-bottom: 144px;
	position: relative;
}

.SliderAnimation-layoutOneBannerSection-dDipx {
	position: relative;
	padding-top: 180px;
	padding-bottom: 180px;
	max-width: 770px;
	margin: 0 auto;
}

.SliderAnimation-layoutOneBannerSection-dDipx h1 {
	color: var(--white-text);
	line-height: 54px;
	text-align: center;
	margin: 38px 0 18px;
	font-size: 48px;
}

.SliderAnimation-sliderContent-OWA11 p,
.SliderAnimation-layoutOneBannerSection-dDipx p,
.SliderAnimation-layoutFormPara-UCMAC {
	text-align: start;
	margin: 0;
	font-size: 18px;
	line-height: 26px;
	font-weight: 500;
}

.SliderAnimation-sliderContent-OWA11 p,
.SliderAnimation-layoutOneBannerSection-dDipx p {
	color: var(--white-text);
	text-align: center;
}

@media (max-width:991px) {
	.SliderAnimation-layoutThreeFormSection-N87QI {
		padding: 15px;
	}
}

@media only screen and (min-width: 1600px) and (max-width: 2048px) {
	.SliderAnimation-sliderContent-OWA11 {
		position: relative;
		padding-top: 18vh;
	}

	.SliderAnimation-downArrow-HusU9 {
		display: none;
	}
}

@media all and (min-width: 1024px) and (max-width: 1280px) {
	.SliderAnimation-BookWrap-WRupq {
		top: 120px;
		left: 30px;
	}
}

@media only screen and (min-width: 1024px) and (max-width: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
	.SliderAnimation-homePosition-qyixY {
		position: relative;
		height: 70vh;
	}
}

@media (max-width: 1023px) and (min-width: 768px) {
	.SliderAnimation-sliderContent-OWA11 h1 {
		color: var(--white-text);
		font-size: 34px;
		line-height: 40px;
	}

	.SliderAnimation-BookWrap-WRupq {
		left: 24px;
	}

	.SliderAnimation-layoutOneBannerSection-dDipx h1 {
		font-size: 34px;
		line-height: 40px;
	}
}

@media only screen and (min-width: 375px) and (max-width: 667px) and (orientation: landscape) {
	.SliderAnimation-homePosition-qyixY {
		position: relative;
		min-height: 560px;
	}

	.SliderAnimation-downArrow-HusU9 {
		position: static;
		margin: -46px 0 0 0;
	}

	.SliderAnimation-sliderContent-OWA11 h1 {
		font-size: 30px;
		line-height: 30px;
	}

	.SliderAnimation-layoutOneBannerSection-dDipx h1 {
		font-size: 30px;
		line-height: 30px;
	}
}

@media only screen and (min-width: 375px) and (max-width: 812px) and (orientation: landscape) {
	.SliderAnimation-homePosition-qyixY {
		position: relative;
		min-height: 630px;
	}

	.SliderAnimation-downArrow-HusU9 {
		display: none;
	}

	.SliderAnimation-sliderContent-OWA11 h1 {
		font-size: 32px;
		line-height: 32px;
	}

	.SliderAnimation-layoutOneBannerSection-dDipx h1 {
		font-size: 32px;
		line-height: 32px;
	}
}

@media screen and (max-width: 640px) {
	.SliderAnimation-sliderContent-OWA11 h1 {
		font-size: 26px;
		width: 100%;
		line-height: 27px;
	}

	.SliderAnimation-searchCss-jJAqN {
		font-size: 13px;
	}

	.SliderAnimation-BookWrap-WRupq {
		width: 90%;
		padding: 15px;
		margin: 0 auto;
		left: 0;
		right: 0;
	}

	.SliderAnimation-BookWrap-WRupq h1 {
		font-size: 26px;
	}

	.SliderAnimation-formHeading-p2WMn {
		font-size: 26px;
	}

	.SliderAnimation-homeCarsoual-FGqLu {
		overflow: hidden;
	}

	.SliderAnimation-layoutOneBannerSection-dDipx h1 {
		font-size: 26px;
		width: 100%;
		line-height: 27px;
	}
}

.SliderAnimation-carBg-RRqgs {
	width: 100%;
	height: 100%;
	background-repeat: no-repeat;
	background-size: cover;
	background-position: 50% 50%;
}`, "",{"version":3,"sources":["webpack://./src/components/Home/SliderAnimation/SliderAnimation.css"],"names":[],"mappings":"AAAA;CACC,cAAc;CACd,oBAAoB;CACpB,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,aAAa;CACb,MAAM;AACP;;AAEA;CACC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,qBAAqB;CACrB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,iBAAiB;AAClB;;AAEA;CACC,wBAAwB;CACxB,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA;CACC,wBAAwB;CACxB,kDAAkD;CAClD,8CAA8C;CAC9C,eAAe;CACf,iBAAiB;AAClB;;AAEA;;;;;;;;;CASC,wBAAwB;CACxB,kDAAkD;CAClD,8CAA8C;AAC/C;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,OAAO;CACP,QAAQ;CACR,UAAU;CACV,kBAAkB;CAElB,2DAAqC;CACrC,mDAA6B;AAC9B;;AAEA;;CAEC;;;;;EAKC,gCAAwB;UAAxB,wBAAwB;CACzB;;CAEA;EACC,oCAA4B;UAA5B,4BAA4B;CAC7B;;CAEA;EACC,oCAA4B;UAA5B,4BAA4B;CAC7B;AACD;;AAjBA;;CAEC;;;;;EAKC,gCAAwB;UAAxB,wBAAwB;CACzB;;CAEA;EACC,oCAA4B;UAA5B,4BAA4B;CAC7B;;CAEA;EACC,oCAA4B;UAA5B,4BAA4B;CAC7B;AACD;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,mCAAmC;CACnC,aAAa;CACb,kBAAkB;CAClB,YAAY;CACZ,uCAAuC;CACvC,UAAU;AACX;;AAEA;CACC,gBAAgB;CAChB,4BAA4B;AAC7B;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,kBAAkB;CAClB,gBAAgB;CAChB,uCAAuC;AACxC;;AAEA;CACC,qCAAqC;CACrC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,4BAA4B;CAC5B,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,4BAA4B;CAC5B,sBAAsB;CACtB,2BAA2B;CAC3B,kBAAkB;CAClB,QAAQ;AACT;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,qBAAqB;CACrB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,wBAAwB;CACxB,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;AAChB;;AAEA;;;CAGC,iBAAiB;CACjB,SAAS;CACT,eAAe;CACf,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;;CAEC,wBAAwB;CACxB,kBAAkB;AACnB;;AAEA;CACC;EACC,aAAa;CACd;AACD;;AAEA;CACC;EACC,kBAAkB;EAClB,iBAAiB;CAClB;;CAEA;EACC,aAAa;CACd;AACD;;AAEA;CACC;EACC,UAAU;EACV,UAAU;CACX;AACD;;AAEA;CACC;EACC,kBAAkB;EAClB,YAAY;CACb;AACD;;AAEA;CACC;EACC,wBAAwB;EACxB,eAAe;EACf,iBAAiB;CAClB;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,eAAe;EACf,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,kBAAkB;EAClB,iBAAiB;CAClB;;CAEA;EACC,gBAAgB;EAChB,mBAAmB;CACpB;;CAEA;EACC,eAAe;EACf,iBAAiB;CAClB;;CAEA;EACC,eAAe;EACf,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,kBAAkB;EAClB,iBAAiB;CAClB;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,eAAe;EACf,iBAAiB;CAClB;;CAEA;EACC,eAAe;EACf,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,eAAe;EACf,WAAW;EACX,iBAAiB;CAClB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,UAAU;EACV,aAAa;EACb,cAAc;EACd,OAAO;EACP,QAAQ;CACT;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,WAAW;EACX,iBAAiB;CAClB;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,4BAA4B;CAC5B,sBAAsB;CACtB,4BAA4B;AAC7B","sourcesContent":[".container {\n\tmargin: 0 auto;\n\tpadding-bottom: 24px;\n\tmax-width: 1274px;\n\tpadding: 0px 15px;\n}\n\n.homeCarsoual {\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100vh;\n\ttop: 0;\n}\n\n.homePosition {\n\tposition: relative;\n\theight: 100vh;\n}\n\n.sliderContent {\n\tposition: relative;\n\tpadding-top: 180px;\n\tpadding-bottom: 180px;\n\tmax-width: 770px;\n\tmargin: 0 auto;\n}\n\n.bgHeight {\n\theight: 100vh;\n\twidth: calc(100% + 5px);\n\tmargin-left: -4px;\n}\n\n.sliderContent h1 {\n\tcolor: var(--white-text);\n\tline-height: 54px;\n\ttext-align: center;\n\tmargin: 38px 0 18px;\n\tfont-size: 48px;\n}\n\n.searchCss {\n\theight: 56px;\n\tpadding: 0 0 0 65px;\n\tfont-size: 20px;\n}\n\n.searchbox {\n\tposition: relative;\n}\n\n.searchIcon {\n\tposition: absolute;\n\ttop: 17px;\n\tleft: 16px;\n}\n\n.searchButton {\n\tposition: absolute;\n\ttop: 7px;\n\tright: 12px;\n}\n\n.searchButton button {\n\tcolor: var(--white-text);\n\tbackground-color: var(--btn-primary-bg) !important;\n\tborder-color: var(--btn-primary-bg) !important;\n\tfont-size: 17px;\n\tpadding: 8px 13px;\n}\n\n.btn-danger.active.focus,\n.btn-danger.active:focus,\n.btn-danger.active:hover,\n.btn-danger:active.focus,\n.btn-danger:active:focus,\n.btn-danger:active:hover,\n.open>.dropdown-toggle.btn-danger.focus,\n.open>.dropdown-toggle.btn-danger:focus,\n.open>.dropdown-toggle.btn-danger:hover {\n\tcolor: var(--white-text);\n\tbackground-color: var(--btn-primary-bg) !important;\n\tborder-color: var(--btn-primary-bg) !important;\n}\n\n.homeCarsoualMobile {\n\tdisplay: none;\n}\n\n.downArrow {\n\tposition: absolute;\n\tbottom: 10px;\n\tleft: 0;\n\tright: 0;\n\tz-index: 0;\n\ttext-align: center;\n\t-moz-animation: bounce 2s infinite;\n\t-webkit-animation: bounce 2s infinite;\n\tanimation: bounce 2s infinite;\n}\n\n@keyframes bounce {\n\n\t0%,\n\t20%,\n\t50%,\n\t80%,\n\t100% {\n\t\ttransform: translateY(0);\n\t}\n\n\t40% {\n\t\ttransform: translateY(-20px);\n\t}\n\n\t60% {\n\t\ttransform: translateY(-10px);\n\t}\n}\n\n.downArrow img {\n\tdisplay: inline-block;\n}\n\n.FormBookWrap {\n\tposition: relative;\n}\n\n.BookWrap {\n\tposition: absolute;\n\ttop: 150px;\n\tbackground: var(--primary-white-bg);\n\tpadding: 30px;\n\tborder-radius: 6px;\n\twidth: 450px;\n\tborder: 1px solid var(--primary-border);\n\tz-index: 1;\n}\n\n.BookWrap h1 span {\n\tmargin: 0 0 10px;\n\tcolor: var(--btn-primary-bg);\n}\n\n.BookWrap h1 {\n\tmargin: 0;\n}\n\n.height100 {\n\theight: 100%;\n}\n\n.layoutThreeFormSection {\n\tbackground: var(--primary-white-bg);\n\tpadding: 30px;\n\tborder-radius: 6px;\n\tmax-width: 450px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.layoutOneAndThreeHomeBanner {\n\tbackground: var(--homePage-Banner-bg);\n\twidth: 100%;\n\theight: 100%;\n}\n\n.formHeading {\n\tcolor: var(--btn-primary-bg);\n\tmargin-bottom: 12px;\n}\n\n.layoutOneAndThreeBgSize {\n\twidth: 100%;\n\theight: 100%;\n\tposition: relative;\n\tmin-height: 768px;\n}\n\n.layoutOneAndThreeBgImg {\n\twidth: 100%;\n\theight: 100%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tbackground-position: center;\n\tposition: absolute;\n\tinset: 0;\n}\n\n.layoutThreeFormContainer {\n\tpadding-top: 144px;\n\tpadding-bottom: 144px;\n\tposition: relative;\n}\n\n.layoutOneBannerSection {\n\tposition: relative;\n\tpadding-top: 180px;\n\tpadding-bottom: 180px;\n\tmax-width: 770px;\n\tmargin: 0 auto;\n}\n\n.layoutOneBannerSection h1 {\n\tcolor: var(--white-text);\n\tline-height: 54px;\n\ttext-align: center;\n\tmargin: 38px 0 18px;\n\tfont-size: 48px;\n}\n\n.sliderContent p,\n.layoutOneBannerSection p,\n.layoutFormPara {\n\ttext-align: start;\n\tmargin: 0;\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 500;\n}\n\n.sliderContent p,\n.layoutOneBannerSection p {\n\tcolor: var(--white-text);\n\ttext-align: center;\n}\n\n@media (max-width:991px) {\n\t.layoutThreeFormSection {\n\t\tpadding: 15px;\n\t}\n}\n\n@media only screen and (min-width: 1600px) and (max-width: 2048px) {\n\t.sliderContent {\n\t\tposition: relative;\n\t\tpadding-top: 18vh;\n\t}\n\n\t.downArrow {\n\t\tdisplay: none;\n\t}\n}\n\n@media all and (min-width: 1024px) and (max-width: 1280px) {\n\t.BookWrap {\n\t\ttop: 120px;\n\t\tleft: 30px;\n\t}\n}\n\n@media only screen and (min-width: 1024px) and (max-width: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {\n\t.homePosition {\n\t\tposition: relative;\n\t\theight: 70vh;\n\t}\n}\n\n@media (max-width: 1023px) and (min-width: 768px) {\n\t.sliderContent h1 {\n\t\tcolor: var(--white-text);\n\t\tfont-size: 34px;\n\t\tline-height: 40px;\n\t}\n\n\t.BookWrap {\n\t\tleft: 24px;\n\t}\n\n\t.layoutOneBannerSection h1 {\n\t\tfont-size: 34px;\n\t\tline-height: 40px;\n\t}\n}\n\n@media only screen and (min-width: 375px) and (max-width: 667px) and (orientation: landscape) {\n\t.homePosition {\n\t\tposition: relative;\n\t\tmin-height: 560px;\n\t}\n\n\t.downArrow {\n\t\tposition: static;\n\t\tmargin: -46px 0 0 0;\n\t}\n\n\t.sliderContent h1 {\n\t\tfont-size: 30px;\n\t\tline-height: 30px;\n\t}\n\n\t.layoutOneBannerSection h1 {\n\t\tfont-size: 30px;\n\t\tline-height: 30px;\n\t}\n}\n\n@media only screen and (min-width: 375px) and (max-width: 812px) and (orientation: landscape) {\n\t.homePosition {\n\t\tposition: relative;\n\t\tmin-height: 630px;\n\t}\n\n\t.downArrow {\n\t\tdisplay: none;\n\t}\n\n\t.sliderContent h1 {\n\t\tfont-size: 32px;\n\t\tline-height: 32px;\n\t}\n\n\t.layoutOneBannerSection h1 {\n\t\tfont-size: 32px;\n\t\tline-height: 32px;\n\t}\n}\n\n@media screen and (max-width: 640px) {\n\t.sliderContent h1 {\n\t\tfont-size: 26px;\n\t\twidth: 100%;\n\t\tline-height: 27px;\n\t}\n\n\t.searchCss {\n\t\tfont-size: 13px;\n\t}\n\n\t.BookWrap {\n\t\twidth: 90%;\n\t\tpadding: 15px;\n\t\tmargin: 0 auto;\n\t\tleft: 0;\n\t\tright: 0;\n\t}\n\n\t.BookWrap h1 {\n\t\tfont-size: 26px;\n\t}\n\n\t.formHeading {\n\t\tfont-size: 26px;\n\t}\n\n\t.homeCarsoual {\n\t\toverflow: hidden;\n\t}\n\n\t.layoutOneBannerSection h1 {\n\t\tfont-size: 26px;\n\t\twidth: 100%;\n\t\tline-height: 27px;\n\t}\n}\n\n.carBg {\n\twidth: 100%;\n\theight: 100%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tbackground-position: 50% 50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SliderAnimation-container-CoqCX`,
	"homeCarsoual": `SliderAnimation-homeCarsoual-FGqLu`,
	"homePosition": `SliderAnimation-homePosition-qyixY`,
	"sliderContent": `SliderAnimation-sliderContent-OWA11`,
	"bgHeight": `SliderAnimation-bgHeight-luFqo`,
	"searchCss": `SliderAnimation-searchCss-jJAqN`,
	"searchbox": `SliderAnimation-searchbox-NIQHA`,
	"searchIcon": `SliderAnimation-searchIcon-JQ9ZT`,
	"searchButton": `SliderAnimation-searchButton-ug6tF`,
	"btn-danger": `SliderAnimation-btn-danger-rnqus`,
	"active": `SliderAnimation-active-ZmYYO`,
	"focus": `SliderAnimation-focus-vghdL`,
	"open": `SliderAnimation-open-bVz8z`,
	"dropdown-toggle": `SliderAnimation-dropdown-toggle-c0Gs8`,
	"homeCarsoualMobile": `SliderAnimation-homeCarsoualMobile-qIi9H`,
	"downArrow": `SliderAnimation-downArrow-HusU9`,
	"bounce": `SliderAnimation-bounce-ZrSKW`,
	"FormBookWrap": `SliderAnimation-FormBookWrap-n8yxr`,
	"BookWrap": `SliderAnimation-BookWrap-WRupq`,
	"height100": `SliderAnimation-height100-vetXF`,
	"layoutThreeFormSection": `SliderAnimation-layoutThreeFormSection-N87QI`,
	"layoutOneAndThreeHomeBanner": `SliderAnimation-layoutOneAndThreeHomeBanner-wdVEt`,
	"formHeading": `SliderAnimation-formHeading-p2WMn`,
	"layoutOneAndThreeBgSize": `SliderAnimation-layoutOneAndThreeBgSize-FsJaf`,
	"layoutOneAndThreeBgImg": `SliderAnimation-layoutOneAndThreeBgImg-dBgup`,
	"layoutThreeFormContainer": `SliderAnimation-layoutThreeFormContainer-tvAOg`,
	"layoutOneBannerSection": `SliderAnimation-layoutOneBannerSection-dDipx`,
	"layoutFormPara": `SliderAnimation-layoutFormPara-UCMAC`,
	"carBg": `SliderAnimation-carBg-RRqgs`
};
module.exports = ___CSS_LOADER_EXPORT___;
